import { Component } from "@angular/core";
import { UserService } from "../../services/user.service";
import { CustomModal } from "../../../core/components/base-modals";
import { config } from "@config";

@Component({
	templateUrl: "./not-found-modal.component.html",
	standalone: false
})
export class NotFoundModalComponent extends CustomModal {
	public constructor(private userService: UserService) {
		super();
	}

	public get link(): string {
		return config.helpcenterUrl + "hc/" + this.userService.user.getShortLang();
	}

	public save(): void {
		// Empty
	}
}
